import { MERCHANT_STATUS } from '@artemis/store/merchant/selectors';
export const getMerchantState = ({ open, state }) => {
  let label = '';
  /* istanbul ignore next */
  switch (state) {
    case MERCHANT_STATUS.unknown:
    case MERCHANT_STATUS.off:
    case MERCHANT_STATUS.down:
    case MERCHANT_STATUS.downManual:
    case MERCHANT_STATUS.lost:
    case MERCHANT_STATUS.accountIssue:
    case MERCHANT_STATUS.downPrompt:
    case MERCHANT_STATUS.downUntilTomorrow:
    case MERCHANT_STATUS.unresponsivePrompt:
    case MERCHANT_STATUS.unresponsiveUntilTomorrow:
    case MERCHANT_STATUS.platformIssue:
      label = 'merchantState.unavailable';
      break;
    case MERCHANT_STATUS.overCapacity:
    case MERCHANT_STATUS.unresponsiveOverCapacity:
      label = 'merchantState.busyShort';
      break;
    case MERCHANT_STATUS.on:
    case MERCHANT_STATUS.whitelist:
    case MERCHANT_STATUS.debug:
    default:
      break;
  }
  if (!open) label = 'merchantState.closedShort';
  return label;
};
